var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ModalcloseReason } from 'hsg';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { ServerResponse } from 'src/app/authentication/constants/server-response.model';
var AuthEndProcessComponent = /** @class */ (function (_super) {
    __extends(AuthEndProcessComponent, _super);
    function AuthEndProcessComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthEndProcessComponent.prototype.ngOnInit = function () {
        this.data = this.modalService.data;
        //this will report 2174 elastic code
        if (this.data.elasticCode) {
            this.authUserService.sendAuthData("ElasticLogger", { elasticCode: this.data.elasticCode })
                .subscribe(function (res) { return console.log("sent elasticLog code:2174 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
            sessionStorage.setItem("elasticCode", "");
            this.isShowContactLink = this.shouldContactLink('authEndProcess');
        }
        if (this.data.ProcessError == ServerResponse.ALREADY_EXIST) {
            this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2176' })
                .subscribe(function (res) { return console.log("sent elasticLog code:2176 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        }
        if (this.data.id == "CUSTOMER_SERVICE")
            this.data.gaLabel = 'User Initiated = ' + (this.data.CustomerServiceReason == 23) + ' - ' + this.data.CustomerServiceReason + ' - ' + this.data.MsgCustomerServiceReason;
        if (this.data.id = "TECHNICAL_ERROR")
            this.data.gaLabel = 'Screen Name = ' + sessionStorage.getItem("currentWindow");
        //sessionStorage.clear();
    };
    AuthEndProcessComponent.prototype.finish = function () {
        this.modalService.close(this.data, ModalcloseReason.buttonX);
    };
    return AuthEndProcessComponent;
}(AuthBaseComponent));
export { AuthEndProcessComponent };
